/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 审核退款详情 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/checkRefundDetail`
 */
const postCheckRefundDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/refund/checkRefundDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckRefundDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 审核退款详情 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/checkRefundDetail`
 */
export const postCheckRefundDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCheckRefundDetailRequestConfig, requestData),
    ...args
  );
};
postCheckRefundDetail.requestConfig = postCheckRefundDetailRequestConfig;
/**
 * 接口 退款审核详情-审核通过 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/changeRefundStatus`
 */
const postChangeRefundStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/refund/changeRefundStatus",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postChangeRefundStatus",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 退款审核详情-审核通过 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/changeRefundStatus`
 */
export const postChangeRefundStatus = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postChangeRefundStatusRequestConfig, requestData),
    ...args
  );
};
postChangeRefundStatus.requestConfig = postChangeRefundStatusRequestConfig;
/**
 * 接口 退款审核列表 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/checkRefund`
 */
const postCheckRefundRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/refund/checkRefund",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckRefund",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 退款审核列表 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/refund/checkRefund`
 */
export const postCheckRefund = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCheckRefundRequestConfig, requestData), ...args);
};
postCheckRefund.requestConfig = postCheckRefundRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 退款-审核列表筛选项 的 **请求配置**
 *
 * @分类 财务API/退款
 * @请求头 `GET /erp/refund/optionsForCheckRefund`
 */
const getOptionsForCheckRefundRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/refund/optionsForCheckRefund",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForCheckRefund",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 退款-审核列表筛选项 的 **请求函数**
 *
 * @分类 财务API/退款
 * @请求头 `GET /erp/refund/optionsForCheckRefund`
 */
export const getOptionsForCheckRefund = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getOptionsForCheckRefundRequestConfig, requestData),
    ...args
  );
};
getOptionsForCheckRefund.requestConfig = getOptionsForCheckRefundRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/refund.js